module.exports = __webpack_public_path__ + "static/media/footerTridiumLogo.f4a88345.svg";